import React from 'react';
import { Spin } from 'antd';
import ReactApexChart from 'react-apexcharts';
import {
  BanknotesIcon,
  ShoppingBagIcon,
} from '@heroicons/react/24/outline';
import WeekSlider from '../../../components/week-slider/week-slider';
import { SegmentedToggle, EmptyState } from '../../../components/ui';
import NoData2 from '../../../assets/no-data-2.svg';

const WeeklyChart = ({
  weekRangeChartType,
  setWeekRangeChartType,
  handleWeekChange,
  loading,
  weekRangeData,
  chart,
}) => {
  const isEmpty = weekRangeData.items.length === 0;

  return (
    <section className="reveal overflow-hidden">
      <header className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="text-base font-bold text-slate-900 dark:text-slate-100">
          Weekly Trend
        </h3>
        <div className="flex flex-wrap items-center gap-3">
          <WeekSlider
            onWeekChange={handleWeekChange}
            weekOfStartMonday={false}
            useNowAsEndDate
          />
          <SegmentedToggle
            ariaLabel="Chart metric"
            value={weekRangeChartType}
            onChange={setWeekRangeChartType}
            options={[
              { value: 'Sales', label: 'Sales', icon: BanknotesIcon },
              { value: 'Items', label: 'Items', icon: ShoppingBagIcon },
            ]}
          />
        </div>
      </header>

      <div className="px-2 pb-4 pt-2">
        {loading ? (
          <div className="flex h-[320px] items-center justify-center">
            <Spin />
          </div>
        ) : isEmpty ? (
          <EmptyState
            variant="plain"
            image={NoData2}
            title="No data for this week"
            description="Try a different week or expand your filters."
          />
        ) : (
          <ReactApexChart
            options={chart.options}
            series={chart.series}
            type="area"
            height={320}
          />
        )}
      </div>
    </section>
  );
};

export default WeeklyChart;
